import { WellbeingReferral } from '@features/wellbeing-referrals/components/WellbeingReferral'
import { allWellbeingReferralsQueryOptions } from '@features/wellbeing-referrals/queries'
import { createFileRoute, notFound } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/referrals/wellbeing/manage/$referralId')({
  component: RouteComponent,
  loader: async ({ params, context }) => {
    const queryOptions = allWellbeingReferralsQueryOptions()
    let referrals = await context.queryClient.ensureQueryData(queryOptions)
    let referral = referrals.find((item) => item.referralId === Number(params.referralId))

    // A live notification can arrive while the referrals query still contains a
    // fresh, pre-submission result. Refresh once before treating the URL as missing.
    if (!referral) {
      referrals = await context.queryClient.fetchQuery({ ...queryOptions, staleTime: 0 })
      referral = referrals.find((item) => item.referralId === Number(params.referralId))
    }

    if (!referral) {
      throw notFound()
    }

    return referral
  },
  staticData: {
    crumb: {
      dynamicLabel: (match) => `#${match.params.referralId}`,
    },
  },
})

function RouteComponent() {
  const referral = Route.useLoaderData()

  return <WellbeingReferral referral={referral} showCounsellingContactDetails />
}
